<template>
  <AppView
    padd-bottom
  >
    <template v-slot:top-app-view>
      <transition name="fade" mode="out-in" appear>
        <CompanyHeader :company="company" :loading="loadingCompany" />
      </transition>
    </template>

    <transition name="fade" mode="out-in" appear>

      <div v-if="errorCompany || errorCompanyProgram" class="tw-mt-12" key="errmsg">
        <p class="tw-py-12 tw-text-base tw-text-center" v-html="errorCompany || errorCompanyProgram"></p>
      </div>

      <div v-else-if="loadingCompany || loadingCompanyProgram" class="tw-mt-12" key="lodng">
        <p class="tw-py-12 tw-text-base tw-text-center">Loading...</p>
      </div>

      <div v-else key="bdy">
        <transition name="fade" mode="out-in" appear>

          <div class="app-view-grid px-body">
            <div class="app-view-grid__col-74">
              <portal to="modal-body" key="mdl">
                <div class="">
                  <EditExpert
                    :company="company"
                    @created-success="closeModal(); getCompanyExperts();"
                  />
                </div>
              </portal>

              <div class="tw-flex tw-items-center tw-mb-5">
                <UserPhoto
                  :photo="activeCompanyProgram.logo"
                  :user-name="{
                    name: activeCompanyProgram.name,
                  }"
                  logo
                  photo-size="tw-h-10 tw-w-10"
                  :class="[
                    'tw-rounded-10--force --force-children tw-bg-app-white-87 tw-mx-2',
                    { 'tw-shadow-app-sm': !(activeCompanyProgram.logo || '').length }
                  ]"
                />

                <p class="tw-font-bold">
                  {{ activeCompanyProgram.name }} Mentorship Program
                </p>
              </div>

              <template>
                <!-- selected program experts -->
                <div v-if="loadingSelectedProgramExperts">
                  <p class="tw-py-12 tw-text-base tw-text-center">Loading program experts...</p>
                </div>

                <div v-else class="tw-rounded-lg tw-border tw-border-app-black-11 tw-p-4 tw-shadow-app">
                  <div class="tw-flex tw-items-start">
                    <h3 class="font-title tw-text-lg tw-tracking-wider">
                      Program Experts
                    </h3>

                    <SelectGroup
                      :options="nonSelectedProgramExperts"
                      label="Add an Expert to this Program"
                      name-key="fullName"
                      class="tw-ml-auto"
                      :reduce="user => user"
                      v-model="selectedExpert"
                    />
                  </div>

                  <div class="tw-flex tw-flex-wrap">
                    <div v-for="expert in selectedProgramExperts" :key="expert.id" class="tw-flex tw-items-center tw-justify-center tw-flex-col tw-mr-4">
                      <UserPhoto
                        :photo="expert.pic"
                        :user-name="{
                          name: expert.name,
                        }"
                        photo-size="tw-h-20 tw-w-20"
                        :class="[
                          'tw-my-1 tw-rounded-10--force --force-children tw-bg-app-white-87',
                        ]"
                      />

                      <p class="tw-text-sm tw-text-center tw-w-20">{{ expert.name }} {{ expert.last_name }}</p>

                      <BaseButton
                        icon
                        alt="Remove Expert"
                        text=""
                        class="tw-border-none tw-bg-red-100 tw-mb-2 tw-text-red-600 transition-slow"
                        @click="removeExpertFromProgram(expert.id)"
                      >
                        <svg slot="icon" class="my-btn__icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                            y="0px" viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
                          <path d="M63.1,15.2V64c0,4.4-3.6,8-8,8h-38c-4.4,0-8-3.6-8-8V15.2c0-1.1,0.8-1.9,1.9-1.9s1.9,0.8,1.9,1.9V64c0,2.3,1.9,4.2,4.2,4.2
                            h38c2.3,0,4.2-1.9,4.2-4.2V15.2c0-1.1,0.8-1.9,1.9-1.9S63.1,14.2,63.1,15.2z M66.3,4.9H38v-3C38,0.8,37.2,0,36.1,0
                            c-1.1,0-1.9,0.8-1.9,1.9v3H5.9C4.7,4.9,4,5.7,4,6.8s0.8,1.9,1.9,1.9h60.2C67.3,8.7,68,8,68,6.8S67.3,4.9,66.3,4.9z M24.7,58.9V17.1
                            c0-1.1-0.8-1.9-1.9-1.9s-1.9,0.8-1.9,1.9v41.8c0,1.1,0.8,1.9,1.9,1.9S24.7,60,24.7,58.9z M38,58.9V17.1c0-1.1-0.8-1.9-1.9-1.9
                            c-1.1,0-1.9,0.8-1.9,1.9v41.8c0,1.1,0.8,1.9,1.9,1.9C37.2,60.8,38,60,38,58.9z M51.3,58.9V17.1c0-1.1-0.8-1.9-1.9-1.9
                            s-1.9,0.8-1.9,1.9v41.8c0,1.1,0.8,1.9,1.9,1.9S51.3,60,51.3,58.9z"/>
                        </svg>
                      </BaseButton>
                    </div>
                  </div>
                </div>
              </template>

              <template>
                <div class="tw-flex tw-items-center tw-pt-10 tw-pb-4">
                  <img
                    data-src="/img/experts.png"
                    src="/img/experts.png"
                    style="width: 80px; height: 80px;"
                    class="tw-object-cover tw-block tw-mr-8"
                    async
                  >
                  <h3 class="font-title tw-text-xl tw-tracking-wider">
                    Company {{ ' ' }} Experts
                  </h3>

                  <BaseButton
                    class="tw-ml-auto"
                    text="Add an Expert"
                    title="Add an Expert"
                    @click="createExpert"
                  />
                </div>
                <div class="tw-border-t tw-border-app-black-11 tw-mb-4"></div>
                <div></div>
              </template>

              <div class="tw-mb-4">
                <label class="tw-text-xs tw-text-black opacity-78">Question Guide for {{ company.company }} Mentees</label>
                <QuillTextareaGroup
                  :rows="3"
                  class="tw-bg-white"
                  v-model="form.instruction"
                  max-height="400px"
                />
                <BaseButton @click="createCompanyQuestionInstruction" text="Save Instruction" class="tw-bg-black tw-border-0 tw-text-white" />
              </div>

              <div class="tw-border-t tw-border-app-black-11 tw-mb-8"></div>

              <!-- Experts -->
              <template>
                <ViewMore
                  :list="experts"
                  :limit="8"
                  class="tw-flex tw-flex-wrap tw-h-auto"
                  v-slot="{ item: expert }"
                >
                  <Expert :expert="expert" class="tw-pr-4 tw-pb-4" show-view-more-button />
                </ViewMore>
              </template>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </AppView>
</template>

<script>
import CompanyHeader from '@/views/Companies/Company/_partials/CompanyHeader.vue';
import EditExpert from '@/views/Companies/Company/_partials/EditExpert.vue';
import Expert from '@/components/Expert.vue';
import QuillTextareaGroup from '@/components/QuillTextareaGroup.vue';
import UserPhoto from '@/components/UserPhoto.vue';
import SelectGroup from '@/components/SelectGroup.vue';

import companyMixin from '@/mixins/company';
import companyProgramMixin from '@/mixins/companyProgram';

const defaultDeleteButtonText = 'Cancel Meeting';

export default {
  name: 'ExpertsView',
  mixins: [companyMixin, companyProgramMixin],
  components: {
    CompanyHeader,
    EditExpert,
    Expert,
    QuillTextareaGroup,
    UserPhoto,
    SelectGroup,
  },
  props: ['id', 'programId'],
  data() {
    return {
      error: undefined,
      loading: true,
      loadingParticipants: true,
      loadingSelectedProgramExperts: true,
      maxVisibleParticipants: 10,
      experts: [],
      selectedProgramExperts: [],
      selectedExpert: undefined,
      newForm: false,
      form: {
        instruction: '',
      },
      deleteButtonDisabled: false,
      deleteButtonText: defaultDeleteButtonText,
    };
  },
  watch: {
    selectedExpert(newVal) {
      if (!newVal?.id) {
        return;
      }

      this.addExpertToProgram(newVal);
    },
  },
  computed: {
    nonSelectedProgramExperts() {
      // eslint-disable-next-line eqeqeq
      return this.experts.filter((expert) => !this.selectedProgramExperts.some((selected) => selected.id == expert.id)).map((expert) => ({
        ...expert,
        fullName: `${expert.name} ${expert.last_name}`,
      }));
    },
  },
  methods: {
    async getCompanyExperts() {
      this.loading = true;

      await this.$nextTick();

      const experts = await this.$store.dispatch('getCompanyExperts', this.company.id);

      if (Array.isArray(experts)) {
        this.experts = experts;
      }

      this.loading = false;
    },
    async getSelectedProgramExperts() {
      this.loadingSelectedProgramExperts = true;

      const experts = await this.$store.dispatch('getCompanyProgramExperts', [this.company.id, this.activeCompanyProgram.id]);

      if (Array.isArray(experts)) {
        this.selectedProgramExperts = experts;
      }

      this.loadingSelectedProgramExperts = false;
    },
    async createExpert() {
      this.newForm = true;

      await this.$nextTick();
      // open modal
      this.$store.commit('openModal', [true]);
    },
    async closeForm() {
      // close modal
      this.closeModal();

      await this.$nextTick();

      this.newForm = false;
    },
    async onSuccess() {
      this.getCompanyExperts();
    },
    async getCompanyQuestionInstructions() {
      const instruction = await this.$store.dispatch('getCompanyQuestionInstruction', this.company.id);

      if (instruction) {
        this.form.instruction = instruction;
      }
    },
    async createCompanyQuestionInstruction() {
      if (!this.form.instruction.length) {
        return;
      }

      const response = await this.$store.dispatch('createCompanyQuestionInstruction', {
        guide: this.form.instruction,
        companyid: this.company.id,
      });

      if (response) {
        this.getCompanyQuestionInstructions();
        this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.editCompanyQuestionInstruction);
      }
    },
    async addExpertToProgram(expert) {
      const response = await this.$store.dispatch('addExpertToProgram', {
        expertid: expert.id,
        progid: this.activeCompanyProgram.id,
      });

      if (response) {
        this.getSelectedProgramExperts();
        this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.addExpertToProgram);
      }
    },

    async removeExpertFromProgram(expertId) {
      const response = await this.$store.dispatch('removeExpertFromProgram', {
        expertid: expertId,
        progid: this.activeCompanyProgram.id,
      });

      if (response) {
        this.getSelectedProgramExperts();
        this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.removeExpertFromProgram);
      }
    },
  },
  async created() {
    // get company
    await Promise.all([
      this.getCompany(),
      this.getCompanyProgram(),
    ]);

    await this.$nextTick();

    // assert user company permissions
    if (!this.hasPermission || !this.hasProgramPermission) {
      this.$router.push({
        name: 'app',
      });

      return;
    }

    this.getCompanyQuestionInstructions();

    await Promise.all([
      this.getCompanyExperts(),
      this.getSelectedProgramExperts(),
    ]);

    await this.$nextTick();

    this.loading = false;
  },
};
</script>

<style>

</style>
